export enum SnapProtectTypeE {
    /**
     * 加入定时计划
     */
    CdpSchedule = '1',
    /**
     * 创建普通快照
     */
    Snap = '0',
}

export enum SnapSourceSelectTypeE {
    /**
     * 加入定时计划
     */
    Single = 'single',
    /**
     * 创建普通快照
     */
    Multi = 'multi',
}

export enum SnapCreateNameLenE {
    Min = 0,
    MultiMax = 251,
    SingleMax = 255,
}

export enum SnapCreateDesLenE {
    Min = 0,
    Max = 255,
}
